import { OWDataType } from "@multiweb/types/contracts";
import { CaseInsensitiveMap } from "../../../../../../Global/Base/DataTypes/CaseInsensitiveMap";
import { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
import { ModelDescriptionsManager } from "../../../../../../OW.Remoting/Remoting/Cache/ClassDescriptionCache/ModelDescriptionsManager";
import { EnumType } from "../../../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { OWManager } from "../../../../../../OW.Remoting/Remoting/OWManager";
import { Control } from "../../../../../UI.BaseControls/Control";
import { GenericControl } from "../../../../../UI.BaseControls/GenericControl";
import { ArrayDataSource } from "../../../../../UI.Controls/DataSource/ArrayDataSource";
import { DropDownButtonItem } from "../../../../../UI.Controls/DropDownMenu/DropDownButtonItem";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuCheckedDGItem } from "../DropDownMenuItems/DropDownMenuCheckedDGItem";
import { FilterGroup } from "../FilterGroup";
import { IFilterUserValue } from "../FilterInterfaces";
import { logger } from "../logger";
import { ValueListButton } from "./ValueListButton";

export class EnumValueListButton extends ValueListButton implements IFilterUserValue {
    private _attrName: string;
    private _className: string;
    private _enumType: EnumType;

    public get userValue(): any {
        return this._selectedItems;
    }

    public set userValue(v: any) {
        this.value = v;
    }

    public override set value(val: any) {
        this._selectedItems = val;
    }

    public override get value(): any {
        if (!this._loadSyncEnumInfo())
            return this._selectedItems;
        else {
            if (!this._selectedItems)
                return ["-1"]; //pomocná hodnota pro použití v podmínce. Ošetřuje situace, kdy není vybraná žádná hodnota a podmínka by obsahovala prázdnou množinu, což by vedlo k chybě.
            const vals: string[] = ["-1"];
            for (const val of this._selectedItems) {
                if (!val)
                    return null;
                if (!this._enumType)
                    return vals.join(", ");
                const enumId = this._getEnumIdForValue(val.value);
                if (enumId != undefined)
                    vals.push(enumId.toString());
            }
            return vals;
        }
    }

    protected _compareFnc(value: string, enumValue: string): boolean {
        enumValue = StringUtils.removeAccents(enumValue.toUpperCase());
        value = StringUtils.removeAccents(value.toUpperCase());
        return enumValue === value;
    }

    private _getEnumIdForValue(val: string): number | undefined {
        for (const item of this._enumType.descriptions) {
            if (this._compareFnc(val, item.Description))
                return item.IntValue;
        }
        return undefined;
    }

    protected static override get observedAttributes(): string[] {
        return ["data-classname", "data-attrname"].concat(Control.observedAttributes);
    }

    private static _enumsType: CaseInsensitiveMap<EnumType> = new CaseInsensitiveMap<EnumType>();

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "data-classname":
                this._className = newVal;
                if (!this._loadSyncEnumInfo())
                    this._loadEnumInfo();
                break;
            case "data-attrname":
                this._attrName = newVal;
                if (!this._loadSyncEnumInfo())
                    this._loadEnumInfo();
                break;
        }
    }

    private _loadSyncEnumInfo(): boolean {
        if (!this._attrName || !this._className)
            return false;
        const index = `${this._className}|${this._attrName}`; // `
        if (EnumValueListButton._enumsType.has(index)) {
            this._enumType = EnumValueListButton._enumsType.get(index);

            return true;
        }

        return false;
    }

    private async _loadEnumInfo(): Promise<void> {
        if (!this._attrName || !this._className)
            return;

        const attrInfo = await ModelDescriptionsManager.instance.getAttributesInfo(this._className, [this._attrName]);

        if (!attrInfo || attrInfo.length == 0) {
            logger.error("Attribute info not loaded");
            return;
        }

        if (attrInfo[0].type !== OWDataType.enum) {
            logger.error("Input type is not enum (%s)", attrInfo[0].type);
            return;
        }

        const enumName = attrInfo[0].additionalTypeName;

        this._enumType = await OWManager.getEnum(enumName);
        EnumValueListButton._enumsType.set(`${this._className}|${this._attrName}`, this._enumType);
    }

    public override async loadItems(): Promise<void> {
        if (this._init)
            return;
        this._init = true;
        const fgroup = GenericControl.findParent(this as HTMLElement, (item) => item instanceof FilterGroup);
        this._valueList = new DropDownMenuCheckedDGItem();

        if (fgroup instanceof FilterGroup) {
            this._className = (fgroup as FilterGroup).parent.objectName;
            this._attrName = (fgroup as FilterGroup).attrName;
            await this._loadEnumInfo();
            const enumDataSource = new ArrayDataSource();
            enumDataSource.init(this._enumType.descriptions, "IntValue");
            enumDataSource.setAttrs(["description"]);
            await this._valueList.valueList.initializeByDS(enumDataSource);
        }

        this._menu.addItem(this._valueList);
        this._valueList.valueList.selectedValues = this._selectedItems;

        const m = new DropDownButtonItem();
        this._appendSelectedValue();

        m.addItem("GUI-311684", () => { //Vybrat
            this._selectedItems = this._valueList.valueList.selectedValues;

            this._appendSelectedValue();

            m.parent.close();

            this.callEvent("change");
        });

        this._menu.addItem(m);
    }
}
registerCustomElement("tsc-EnumValueListButton", EnumValueListButton);
